import './theme/colors.css'
import './theme/globals.css'

import { PostHogProvider } from '@posthog/react'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { initPostHog } from './integrations/posthog'
import { initSentry } from './integrations/sentry'
import { routeTree } from './routeTree.gen'

initSentry()

const posthogClient = initPostHog()

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  type Register = {
    router: typeof router
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider client={posthogClient}>
      <RouterProvider router={router} />
    </PostHogProvider>
  </StrictMode>,
)
